import { render, staticRenderFns } from "./NoContent2.vue?vue&type=template&id=6a6bfc38&scoped=true"
import script from "./NoContent2.vue?vue&type=script&lang=js"
export * from "./NoContent2.vue?vue&type=script&lang=js"
import style0 from "./NoContent2.vue?vue&type=style&index=0&id=6a6bfc38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6bfc38",
  null
  
)

export default component.exports